module.exports = __webpack_public_path__ + "static/media/TheCount.62eb89b7.jpg";